"use client";

import * as React from "react";

export interface PageOverlaysProps {
  children?: React.ReactNode;
}

export function PageOverlays({ children }: PageOverlaysProps) {
  if (!children) return null;
  return <>{children}</>;
}
